import './wdyr';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './components/App';
import './satoshi.css';
import { toast, Toaster } from './common/toast';
import { GoogleOAuthProvider } from '@react-oauth/google';
import {
  registerAppServiceWorker,
  activateWaitingServiceWorker,
  initAppServiceWorkerMessageBridge,
  initVisibilityAwareAuthPoll,
} from './service_worker/client';
import reportWebVitals from './reportWebVitals';
import {ErrorBoundary} from 'react-error-boundary'
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import logger from './utils/logger';
// import { AuthProvider } from './components/AuthContextProvider';
import { UserProvider } from './components/UserContext';
import { CourtDateProvider } from './components/CourtDateProvider';
import {StableRouterContextProvider} from './common/StableRouterContextProvider.js'
// import { AnalyticsProvider } from '@propriety/analytics';

// Directly writing out token since its publishable and non secret.
const MIXPANEL_TOKEN = '499d93415a9cc25c31017222ad6b73d2';

// import { initMixpanel } from '@propriety/analytics';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
// a little dumb to do it like this?
// Run version check
// checkVersion();

// turn this error fallback into a proper "within your application" 404 error type page
// Custom error fallback component to display errors
function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div className="text-red-500 text-xl mt-8 m-auto text-center font-bold">
      <h2>Something went wrong:</h2>
      <pre>{error.message}</pre>
      <button
        onClick={resetErrorBoundary}
        className="mt-4 p-2 bg-blue-500 text-white rounded"
      >
        Try again
      </button>
    </div>
  );
}


root.render(
  <BrowserRouter>
  <GoogleOAuthProvider clientId="511916914273-ip82hd3h57cjkjc00o6qoromqh89d32e.apps.googleusercontent.com">
    <Toaster position="top-right" richColors closeButton duration={3000} toastOptions={{ style: { whiteSpace: 'pre-line' } }} />
  <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={(error, info) => {
          logger.error("Error Boundary caught an error:", error);
          logger.error("Error Info:", info);
          toast.error(`Unexpected error: ${error.message}`);
        }}
      >
      {/* custom stable usenavigate + location context */}
      <StableRouterContextProvider>
      {/* User auth context */}
      <UserProvider>
        {/* Court date context - only loads after authentication */}
        <CourtDateProvider>
          {/* <AnalyticsProvider 
            mixpanelToken={MIXPANEL_TOKEN}
            trackingDomain={isBrowser ? window.location.hostname : ''}
            disabled={process.env.NODE_ENV === 'development'} // Optional
          > */}
            <App/>
          {/* </AnalyticsProvider> */}
        </CourtDateProvider>
      </UserProvider>
    </StableRouterContextProvider>
    </ErrorBoundary>
    </GoogleOAuthProvider>
  </BrowserRouter>
);

initAppServiceWorkerMessageBridge();
initVisibilityAwareAuthPoll();

registerAppServiceWorker({
  onUpdate: (registration) => {
    toast.info('New version available. Click Update to reload.', {
      autoClose: false,
      action: {
        label: 'Update',
        onClick: () => activateWaitingServiceWorker(registration),
      },
    });
  },
});

reportWebVitals();